<template>
	<div>
		<section class="section intro">
			<div class="fondoOscuro">
				<div class="container">
					<div class="columns is-desktop">
						<div class="column is-offset-0-desktop is-8-tablet is-offset-2-tablet">
							<img src="@/assets/img/logoblanco.png" alt="" class="logo">
							<h1>Quinielazo.com</h1>
							<h2>Haz tu quiniela Gratis y diviertete con tus amigos</h2>
							<p>Juega y demuestra tu conocimiento semana a semana usando quinielazo.com, es facil y muy sencillo y lo mejor de todo GRATIS</p>
							<!-- Botones sociales -->
							<div class="buttons">
								<div class="buttonfb fb-like" data-href="https://www.facebook.com/quinielazo" data-width="" data-layout="box_count" data-action="like" data-size="small" data-share="false"></div>
								<a class="button is-link is-info" href="https://twitter.com/intent/tweet?original_referer=http%3A%2F%2Fquinielazo.com%2F&ref_src=twsrc%5Etfw&text=Quinielazo.com%3A%20Quinielas%20gratis%20para%20ti%20y%20tus%20amigos%2C%20entra%2C%20juega%20y%20diviertete&tw_p=tweetbutton&url=http%3A%2F%2Fquinielazo.com" target="_blank">
									<font-awesome-icon class="is-hidden-tablet" :icon="['fab','twitter']" size="1x" />
									<span class="icon is-hidden-mobile"><font-awesome-icon :icon="['fab','twitter']" size="1x" /></span>
									<span class="is-hidden-mobile">Tweet</span>
								</a>
							</div>
							<!-- /Botones sociales -->
						</div>

						<div class="column is-4-desktop is-offset-0-desktop is-8-tablet is-offset-2-tablet">
							<div class="engage">
								<h3>Que necesitas para participar?</h3>
								<p>Solo ser miembro de este sitio!! en 2 sencillos pasos, Registrate y Participa</p>
								
								<div class="columns is-multiline is-mobile">
									<div class="column is-full-desktop">
										<h2 class="truncate">Soy Nuevo!!</h2>
										<button class="button is-info is-fullwidth" @click="openRegister" @keyup.esc="closeRegister">Registrate</button>
									</div>
									<div class="column is-full-desktop">
										<h2 class="truncate">Ya soy Miembro!!</h2>
										<button class="button is-info is-fullwidth" @click="openLogin" @keyup.esc="closeLogin">Inicia sesión</button>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>

		<section class="section info">
			<div class="container">
				<h3>Que es?</h3>
				<p>Quinielazo es un juego en línea para realizar apuestas de futbol con tus amigos</p>
				
				<div class="columns icons">
					<div class="column">
						<div class="columns is-mobile">
							<div class="column is-3">
	              				<font-awesome-icon icon="calendar-alt" size="3x" />
							</div>
							<div class="column desc"><p>Escoge tus partidos, de los diferentes torneos o ligas</p></div>
						</div>
					</div>
					<div class="column">
						<div class="columns is-mobile">
							<div class="column is-3">
								<font-awesome-icon icon="users" size="3x" />
							</div>
							<div class="column desc"><p>Elije tu rival, quinielazo o tus amigos.</p></div>
						</div>
					</div>
					<div class="column">
						<div class="columns is-mobile">
							<div class="column is-3">
								<font-awesome-icon icon="check-square" size="3x" />
							</div>
							<div class="column desc"><p>Checa tus resultados y el de tus amigos, y ve quien fue el mejor</p></div>
						</div>
					</div>
				</div>
			</div>
		</section>

		<section class="section posiciones">
			<div class="container">
				<h3>Posiciones</h3>
				
				<div class="columns icons">
					<div class="column">
						<router-link class="" to="/estadistica">
							<div class="columns is-mobile">
								<div class="column is-3"><font-awesome-icon icon="user" size="3x" /></div>
								<div class="column desc">Mejor Jugador</div>
							</div>
						</router-link>
					</div>
					<div class="column">
						<router-link class="" to="/estadistica">
							<div class="columns is-mobile">
								<div class="column is-3"><font-awesome-icon icon="trophy" size="3x"/></div>
								<div class="column desc">Ir al top 10 de quinielazo</div>
							</div>
						</router-link>
					</div>
					<div class="column">
						<router-link class="" to="/estadistica">
							<div class="columns is-mobile">
								<div class="column is-3"><font-awesome-icon icon="chart-bar" size="3x"/></div>
								<div class="column desc">La estadistica de quinielazo, los mejores jugadores se enlistan aquí</div>
							</div>
						</router-link>
					</div>
				</div>
			</div>
		</section>
	
		<Footer />

	</div>
</template>

<script>
import '@/assets/styles/LandingMain.css'
import Footer from '@/components/Footer'

export default {
	components: {Footer },
  	name: 'LandingMain',

	data() {
		return {

		};
	},
	methods: {
		openLogin(){
			this.$store.dispatch('login/loginOpen')
		},
		openRegister(){
			this.$store.dispatch('login/registroOpen')
		}
	},
	metaInfo(){
		return{
			title: 'Quinielazo.com: Quinielas gratis para ti y tus amigos, entra, juega y diviertete',
			meta:[
				{
					name: 'description',
					content: 'Quinielas de futbol Gratis para ti y tus amigos, es un juego que te permite realizar quinielas online con los partidos de futbol soccer que ocurren en la actualidad y te permite competir con tus amigos y divertirte.'
				},
					{
						property: 'og:title',
						content: 'Quinielazo.com: Quinielas gratis',
					},
					{
						property: 'og:description',
						content: 'Quinielas Gratis para ti y tus amigos, entra, juega y diviertete.',
					},
					{
						property: 'og:image',
						content: 'https://' + window.location.hostname + '/img/icons/android-chrome-384x384.png'
					},
					{
						property: 'og:locale',
						content: 'es_MX'
					},
					{
						property: 'og:site_name',
						content: 'Quinielazo'
					},
					{
						property: 'og:url',
						content: 'https://' + window.location.hostname
					}
			]
		}
	}
};
</script>

<style lang="css" scoped>
.buttonfb{
	padding-right: 1em;
	margin-bottom: 0.5rem;
}
.fb_iframe_widget_fluid{
	display: inline-block !important;
}
</style>
